<script lang="ts">
  import useActiveCategory from '../hooks/use-active-category'
  import { createEventDispatcher, onDestroy } from 'svelte'
  import CategoryBackdrop from './CategoryBackdrop.svelte'
  import CategoryHeader from './CategoryHeader.svelte'
  import CategoryFooter from './CategoryFooter.svelte'
  import CategoryBody from './CategoryBody.svelte'
  import { fly } from 'svelte/transition'

  export let id: string

  let open = false

  const dispatch = createEventDispatcher()
  const { activeId, transitionDuration, closeActive } = useActiveCategory()
  const unsubscribe = activeId.subscribe((value) => (open = value === id))
  const onKeyup = ({ key }: KeyboardEvent) => key === 'Escape' && closeActive()

  onDestroy(unsubscribe)

  $: if (open) {
    dispatch('open')
    document.body.classList.add('overflow-hidden')
  } else {
    dispatch('close')
    document.body.classList.remove('overflow-hidden')
  }
</script>

<svelte:window on:keyup={onKeyup} />

{#key open}
  <div
    class="fixed inset-0 z-20 overflow-y-auto overflow-x-hidden outline-none"
    class:hidden={!open}
    tabindex="-1"
    on:click|self={closeActive}
    transition:fly={{ duration: transitionDuration, y: 100 }}
    {...$$restProps}
  >
    <div
      class="pointer-events-none relative mx-auto h-full min-h-full w-auto max-w-screen-lg sm:px-3 sm:py-6"
    >
      <div
        class="pointer-events-auto relative flex h-full max-h-full w-full flex-col divide-y overflow-hidden bg-white shadow-lg outline-none sm:h-auto sm:rounded-sm"
      >
        <CategoryHeader on:close={closeActive} on:reset />
        <CategoryBody>
          <slot />
        </CategoryBody>
        <CategoryFooter />
      </div>
    </div>
  </div>
  <CategoryBackdrop {open} {transitionDuration} />
{/key}
